<template>
  <div>
    <lk-card :title="notPrescription ? '订单信息' : '处方信息'">
      <div ref="prescriptionPart" class="prescription-page">
        <lk-form
          ref="prescription"
          :label-width="90"
          :rules="salePrescription"
          :model="info"
        >
          <div v-if="!notPrescription">
            <lk-row :gutter="16">
              <lk-col span="11">
                <lk-form-item
                  label="处方医生:"
                  prop="prescriptionDoctor"
                  :class="{ 'ivu-form-item-required': isDataLinkRx }"
                >
                   <lk-auto-complete
                    v-if="able"
                    :clearable='true'
                    :maxlength="30"
                    ref="prescription2"
                    v-model="info.prescriptionDoctor"
                    @on-change="handleSearch1"
                    @on-select='handleSelect'
                    @on-focus='handleFoucus'
                    placeholder="可通过医生姓名搜索"
                    >
                    <template>
                      <div class="test1" v-if='doctorList'>
                        <lk-option v-for="item in doctorList" :value="item.doctorCode" :key='item.doctorCode'>{{`${item.doctorName}-${item.hospitalName}-${item.deptName}`}}</lk-option>
                      </div>
                      <div v-else>
                        <div v-if="isEmpty" class="nodata">
                          暂无数据
                        </div>
                      </div>
                    </template>
                  </lk-auto-complete>
                  <span v-else>{{ info.prescriptionDoctor }}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="11">
                <lk-form-item
                  label="处方医院:"
                  prop="prescriptionHospital"
                  :class="{ 'ivu-form-item-required': isDataLinkRx }"
                >
                  <prescriptionHospital
                    v-if="able"
                    :maxlength="100"
                    ref="prescription1"
                    placeholder="请输入"
                    v-model="info.prescriptionHospital"
                  ></prescriptionHospital>
                  <span v-else>{{ info.prescriptionHospital }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="11">
                <lk-form-item label="科室:" prop="hospitalDept">
                  <lk-input
                    v-if="able"
                    :maxlength="20"
                    ref="prescription5"
                    placeholder="请输入"
                    v-model="info.hospitalDept"
                  ></lk-input>
                  <span v-else>{{ info.hospitalDept }}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="11">
                <lk-form-item
                  label="处方单号:"
                  offset="1"
                  prop="prescriptionNo"
                >
                  <lk-input
                    v-if="able"
                    :maxlength="20"
                    ref="prescription0"
                    placeholder="请输入"
                    v-model="info.prescriptionNo"
                  ></lk-input>
                  <span v-else>{{ info.prescriptionNo }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="8" >
              <lk-col span="11">
                <lk-form-item label="处方时间:" prop="prescriptionTime">
                  <timeStampDatePicker
                    style="width: 100%"
                    ref="prescription4"
                    placeholder="请选择"
                    v-if="able"
                    v-model="info.prescriptionTime"
                  ></timeStampDatePicker>
                  <span v-else>{{ info.prescriptionTime | formatDate }}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="11">
                <lk-form-item label="问诊医生:" prop="inquiryDoctor">
                    <lk-input
                      v-if="able"
                      :maxlength="100"
                      placeholder="请输入"
                      v-model="info.inquiryDoctor"
                    ></lk-input>
                    <span v-else>{{ info.inquiryDoctor }}</span>
                  </lk-form-item>
                </lk-col>
            </lk-row>
            <lk-row :gutter="16">
                 <lk-col span="11">
                  <lk-form-item label="问诊医院:" prop="inquiryHospital">
                    <lk-input
                      v-if="able"
                      :maxlength="100"
                      ref="prescription12"
                      placeholder="请输入"
                      v-model="info.inquiryHospital"
                    ></lk-input>
                    <span v-else>{{ info.inquiryHospital }}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="11">
                  <lk-form-item label="联系人:" prop="contact">
                    <Contact
                      v-model.trim="info.contact"
                      :ifAble="able"
                      @contactValue="contactValue"
                    ></Contact>
                  </lk-form-item>
                </lk-col>
            </lk-row>
            <lk-row :gutter="16">
                <lk-col span="11">
                  <lk-form-item label="联系人电话:" prop="contact">
                    <lk-input v-model="info.contactPhone" class="item" clearable></lk-input>
                  </lk-form-item>
                </lk-col>
            </lk-row>
            <lk-divider class="divider"/>
            <lk-row :gutter='16'>
              <lk-col span="14">
                <lk-form-item label="患者检索:" v-if="able">
                  <prescriptionSearch
                    @selected="importPresription"
                    :type="type"
                    :disabled1="canWrite"
                  >
                  </prescriptionSearch>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="11">
                <lk-form-item label="患者姓名:" prop="patientName">
                  <lk-input
                    v-if="able"
                    :maxlength="32"
                    ref="prescription6"
                    placeholder="请输入"
                    :disabled="canWrite"
                    v-model="info.patientName"
                  ></lk-input>
                  <span v-else>{{ info.patientName }}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="9">
                <lk-form-item label="患者性别:" prop="patientGender">
                  <lk-radio-group
                    ref="prescription9"
                    v-if="able"
                    v-model="info.patientGender"
                  >
                    <lk-radio
                      v-for="(item, index) in genderList"
                      :label="index * 1"
                      :key="index"
                    >
                      <span>{{ item }}</span>
                    </lk-radio>
                  </lk-radio-group>
                  <span v-else>{{ genderList[info.patientGender] }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="11">
                <lk-form-item label="患者年龄:" prop="patientAge">
                  <lk-input
                    style="width: 100%"
                    :maxlength="4"
                    ref="prescription10"
                    v-if="able"
                    number
                    placeholder="请输入"
                    v-model="info.patientAge"
                  ></lk-input>
                  <span v-else>{{ info.patientAge }}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="11">
                <lk-form-item label="证件号码:" prop="patientIdCard">
                  <CredentialsInput
                    :able="able"
                    v-model.trim="info"
                    @setRules="setRules"
                    placeholder='请输入'
                  ></CredentialsInput>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="11">
                <lk-form-item label="联系方式:" prop="patientPhone">
                  <lk-input
                    v-if="able"
                    :maxlength="50"
                    ref="prescription7"
                    placeholder="请输入"
                    :disabled="canWrite"
                    v-model="info.patientPhone"
                  ></lk-input>
                  <span v-else>{{ info.patientPhone }}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="11">
                <lk-form-item
                  label="诊断说明:"
                  prop="diseaseId"
                  :class="{ 'ivu-form-item-required': isDataLinkRx }"
                >
                  <lk-select
                    ref="prescription3"
                    @on-keydown="handleHotKey($event, 'prescription3')"
                    v-if="able"
                    filterable
                    v-model="info.diseaseId"
                    @on-change="setAdditionalRemark"
                  >
                    <lk-option
                      v-for="(item, index) in diseaseList"
                      :key="index"
                      :value="item.id"
                      >{{ item.diseaseName }}</lk-option
                    >
                  </lk-select>
                  <span v-else>{{ info.diseaseName }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col :span='22'>
                <lk-form-item label='患者地址:'>
                  <div class="editRow" v-if='able'>
                    <location style="width:40%" v-model="info.locationArr" @on-change="changeLocation"></location>
                    <lk-input style="width:60%" v-model="info.address"></lk-input>
                  </div>
                  <div v-else>
                    <span>{{info.locationString}}</span>&nbsp;
                    <span>{{info.address}}</span>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="22">
                <lk-form-item
                  label="诊断补充说明:"
                  prop="additionalRemark"
                  :class="{
                    'ivu-form-item-required': info.diseaseName === '其他',
                  }"
                >
                  <lk-input
                    v-if="able"
                    :maxlength="100"
                    ref="prescription11"
                    placeholder="请输入"
                    v-model="info.additionalRemark"
                  ></lk-input>
                  <span v-else>{{ info.additionalRemark }}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-divider />
          </div>
          <lk-row :gutter="16">
            <lk-col span="23">
              <lk-form-item
                :label="notPrescription ? '商品明细:' : '处方商品:'"
                prop="name"
              >
                <lk-button
                  v-if="able"
                  class="mb8"
                  type="primary"
                  @click="$emit('handlePrescriptionGoods', true)"
                  >编辑处方商品</lk-button
                >
                <div class="goodsTable" v-if="showGoodsTable">
                  <table>
                    <thead>
                      <tr>
                        <td>商品通用名</td>
                        <td>商品名</td>
                        <td v-if="showSpec">规格</td>
                        <td>购买数量</td>
                        <td>用法</td>
                        <td>频次</td>
                        <td>每次用量</td>
                        <td>开始用药时间</td>
                        <td>用药周期</td>
                        <td>用药提醒天数</td>
                      </tr>
                    </thead>
                    <tbody
                      v-if="info.saleUsageList && info.saleUsageList.length"
                    >
                      <template v-for="(item, index) in info.saleUsageList">
                        <tr :key="index">
                          <td>
                            {{
                              item.approvedDrugNames || item.approvedDrugName
                            }}
                          </td>
                          <td>
                            {{
                              item.goodsName || ''
                            }}
                          </td>
                          <td v-if="showSpec">{{ item.spec }}</td>
                          <td>{{ item.goodsCount }}</td>
                          <td>
                            <select-input
                              v-if="able"
                              size="small"
                              v-model="info.saleUsageList[index].goodsUsageType"
                              :otherStr="info.saleUsageList[index].goodsUsage"
                              :options="baseData.usageArr"
                              name="dictionaryName"
                              keyName="dictionaryIndex"
                              @setOther="
                                (val) => {
                                  info.saleUsageList[index].goodsUsage = val;
                                }
                              "
                            >
                            </select-input>
                            <span v-else>{{
                              info.saleUsageList[index].goodsUsage ||
                              exchangeDictionary(
                                baseData.usageArr,
                                info.saleUsageList[index].goodsUsageType
                              )
                            }}</span>
                          </td>
                          <td>
                            <select-input
                              v-if="able"
                              v-model="info.saleUsageList[index].frequency"
                              :otherStr="
                                info.saleUsageList[index].frequencyName
                              "
                              size="small"
                              :options="baseData.frequencyArr"
                              name="dictionaryName"
                              keyName="dictionaryIndex"
                              @setOther="
                                (val) => {
                                  info.saleUsageList[index].frequencyName = val;
                                }
                              "
                            >
                            </select-input>
                            <span
                              v-else-if="
                                info.saleUsageList[index].frequency ||
                                info.saleUsageList[index].frequencyName
                              "
                              >{{
                                info.saleUsageList[index].frequencyName ||
                                exchangeDictionary(
                                  baseData.frequencyArr,
                                  info.saleUsageList[index].frequency ||
                                    info.saleUsageList[index].frequencyName
                                )
                              }}</span
                            >
                          </td>
                          <td>
                            <lk-input
                              v-if="able"
                              size="small"
                              :maxlength="20"
                              :ref="`prescription${14 + index * 5}`"
                              placeholder="请输入"
                              v-model="info.saleUsageList[index].goodsDosage"
                            >
                            </lk-input>

                            <span v-else>{{
                              info.saleUsageList[index].goodsDosage
                            }}</span>
                          </td>
                          <td>
                            <timeStampDatePicker
                              style="width: 100%"
                              size="small"
                              v-if="able"
                              :ref="`prescription${15 + index * 5}`"
                              placeholder="请输入"
                              v-model="info.saleUsageList[index].usageStartTime"
                            >
                            </timeStampDatePicker>
                            <span v-else>{{
                              info.saleUsageList[index].usageStartTime
                                | formatDate
                            }}</span>
                          </td>
                          <td>
                            <lk-input-number
                              style="width: 100%"
                              v-model="
                                info.saleUsageList[index].medicationCycle
                              "
                              :min="0"
                              size="small"
                              v-if="able"
                              :maxlength="10"
                            ></lk-input-number>
                            <span v-else>{{
                              info.saleUsageList[index].medicationCycle
                            }}</span>
                          </td>
                          <td>
                            <lk-input-number
                              style="width: 100%"
                              v-model="
                                info.saleUsageList[index].rebuyRemindDays
                              "
                              :min="0"
                              size="small"
                              v-if="able"
                              :maxlength="10"
                            ></lk-input-number>
                            <span v-else>{{
                              info.saleUsageList[index].rebuyRemindDays
                            }}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </lk-form-item>
            </lk-col>
          </lk-row>
           <lk-row :gutter="16">
              <lk-col span="11">
                <lk-form-item label="调配人:" prop="allocater">
                  <lk-select
                    :ref="'prescription-2'"
                    placeholder="请输入"
                    v-if="able || ablePharmacistList"
                    @on-change="
                      exchangePharmacistList(info.allocater, 'reviewerName')
                    "
                    v-model="info.allocater"
                    filterable
                  >
                    <lk-option
                      v-for="(item,index) in pharmacistList"
                      :key="index"
                      :value="item.id"
                      >{{ item.name }}</lk-option
                    >
                  </lk-select>
                  <span v-else>{{ info.allocaterName }}</span>
                </lk-form-item>
              </lk-col>
                <lk-col span="11">
                  <lk-form-item label="复核人:" prop="reviewer">
                    <lk-select
                      :ref="'prescription-1'"
                      v-model="info.reviewer"
                      v-if="able || ablePharmacistList"
                      @on-change="
                        exchangePharmacistList(info.reviewer, 'reviewerName')
                      "
                      placeholder="请输入"
                      filterable
                    >
                      <lk-option
                        v-for="(item,index) in pharmacistList"
                        :key="index"
                        :value="item.id"
                        >{{ item.name }}</lk-option
                      >
                    </lk-select>

                    <span v-else>{{ info.reviewerName }}</span>
                  </lk-form-item>
                </lk-col>

            </lk-row>
        </lk-form>
      </div>
      <div class="image-container" :class="{'image-container-deteail' : !able}">
        <prescriptionImage
         :isAbleUpload='isAbleUpload'
         :able='able'
         v-model="info.picUrls"
         :url="info.picUrls"/>
      </div>
    </lk-card>
  </div>
</template>
<script>
import timeStampDatePicker from '../timeStampDatePicker.vue';
import utils from '../../libs/utils.js';
import prescriptionImage from './Image';
import prescriptionSearch from '../prescription/PatientSearch';
import prescriptionHospital from '../prescription/PrescriptionHospital.vue';
import goods from '../../services/goods';
import SelectInput from '../selectInput.vue';
import CredentialsInput from '../CredentialsInput';
import Contact from './Contact';
import location from '../location.vue';

export default {
  name: 'prescriptionCommon',
  components: {
    timeStampDatePicker,
    prescriptionSearch,
    SelectInput,
    prescriptionHospital,
    CredentialsInput,
    prescriptionImage,
    Contact,
    location,
  },
  props: {
    isAbleUpload: {
      type: Boolean,
      default: false,
    },
    able: {
      type: Boolean,
    },
    isPrescription: {
      type: Boolean,
    },
    isDataLinkRx: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
    genderList: {
      type: Object,
      default() {
        this[1] = '男';
        this[2] = '女';
        return this;
      },
    },
    pharmacistList: {
      type: Array,
    },
    ablePharmacistList: {
      default: false,
    },
    showSpec: {
      // 是否显示商品规格
      default: true,
    },
    canWrite: {
      type: Boolean,
      default: false,
    },
    type: {},
    diseaseList: { type: Array, default: () => [] },
    // 多图
    multiple: {
      default: false,
    },
  },
  model: {
    prop: 'data',
    event: 'change',
  },
  computed: {
    notPrescription() {
      return this.info.type === 2;
    },
  },
  watch: {
    data: {
      handler() {
        const tempUrl = this.info.picUrl || '';
        this.info = this.data;
        if (tempUrl) {
          this.info.picUrl = tempUrl;
        }
      },
      deep: true,
    },
    info: {
      handler() {
        this.able
          && this.info.saleUsageList.forEach((item) => {
            // 处理输入问题，后续考虑其他方式解决
            item.medicationCycle || (item.medicationCycle = null);
            item.rebuyRemindDays || (item.rebuyRemindDays = null);
          });
      },
      deep: true,
    },
  },
  data() {
    return {
      isEmpty: false,
      selectStatus: false,
      doctorList: [],
      currentDoctorId: '',
      showGoodsTable: true,
      baseData: {},
      isValidated: false,
      info: {
        picUrl: '',
        patientIdCard: '',
        permissionType: null,
        saleUsageList: [],
      },
      salePrescription: {},
    };
  },
  methods: {
    changeLocation(val) {
      if (val) {
        this.info.provinceId = val[0];
        this.info.cityId = val[1];
        this.info.countyId = val[2];
        delete this.info.provinceName;
        delete this.info.cityName;
        delete this.info.countyName;
      }
    },
    handleFoucus() {
      this.isEmpty = false;
    },
    handleSelect(value) {
      this.selectStatus = true;
      this.doctorList.forEach((item) => {
        if (item.doctorCode == value) {
          this.$nextTick(() => {
            this.info.prescriptionDoctor = item.doctorName;
            this.info.prescriptionDoctorId = item.doctorCode;
            this.info.prescriptionHospital = item.hospitalName;
            this.info.hospitalDept = item.deptName;
            this.doctorList = [];
            this.$emit('change', this.info);
          });
        }
      });
    },
    handleSearch1: utils.debounce(
      function a(value) {
        if (this.selectStatus) {
          this.selectStatus = false;
          return;
        }
        if (!value) {
          this.isEmpty = false;
          return;
        }
        this.isEmpty = false;
        this.info.prescriptionDoctorId = '';
        this.$emit('change', this.info);
        this.doctorList = [];
        this.$store.commit('setDisableLoading', true);
        goods.getDoctorList({ param: value }).then((res) => {
          if (res.status === 200) {
            this.doctorList = res.data.data;
            if (!this.doctorList) {
              this.isEmpty = true;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }, 2000,
    ),
    setRules(type) {
      this.salePrescription.patientIdCard
        && (this.salePrescription.patientIdCard[0].credentialsType = type);
    },
    setAdditionalRemark() {
      this.info.diseaseName = this.diseaseList.length && this.info.diseaseId
        ? this.diseaseList.find(item => item.id === this.info.diseaseId)
          .diseaseName
        : '';
      if (this.info.diseaseName === '其他') {
        this.salePrescription.additionalRemark = [
          { required: true, message: '请输入诊断补充说明', trigger: 'blur' },
        ];
      } else {
        this.salePrescription.additionalRemark = [{ required: false }];
        this.diseaseList.length
          && this.$nextTick(() => {
            this.$refs.prescription.validateField('additionalRemark', () => {});
          });
      }
    },
    exchangeDictionary(arr, index) {
      return utils.exchangeDictionary(arr, index);
    },
    getBaseData() {
      return new Promise((resolve, reject) => {
        goods
          .GoodsDictionary()
          .then((res) => {
            if (res.data.status === 200) {
              this.baseData.usageArr = [];
              this.baseData.frequencyArr = [];
              res.data.data.forEach((item) => {
                switch (item.dictionaryType) {
                  case 14:
                    this.baseData.usageArr.push(item);
                    break;
                  case 15:
                    this.baseData.frequencyArr.push(item);
                    break;

                  default:
                    break;
                }
              });
              resolve();
            } else {
              this.$Message.error(res.data.error);
            }
          })
          .catch((err) => {
            utils.handleError(err);
            reject(err);
          });
      });
    },
    importPresription(data) {
      console.log(data);
      data.salePrescription.saleUsageList = [];
      this.info.saleUsageList.forEach((item, index) => {
        data.salePrescription.saleUsageList[index] = {};
        data.saleUsageList.forEach((subItem) => {
          if (subItem.goodsStoreId === item.goodsStoreId) {
            subItem.goodsCount = item.goodsCount;
            item = Object.assign(item, subItem);
          }
        });
      });

      data.salePrescription.id = this.info.id;
      data.salePrescription.saleUsageList = this.info.saleUsageList;
      data.salePrescription.picUrls = this.info.picUrls || '';
      data.salePrescription.epId = 0;
      this.info = data.salePrescription;
      this.setAdditionalRemark();
      this.isValidated
        && this.$nextTick(() => {
          this.validate();
        });
      this.$emit('change', this.info);
    },
    setSaleUsageList(list) {
      list.forEach((item) => {
        item.medicationCycle || (item.medicationCycle = null);
        item.rebuyRemindDays || (item.rebuyRemindDays = null);
        this.info.saleUsageList.forEach((subItem) => {
          if (item.goodsStoreId === subItem.goodsStoreId) {
            delete subItem.goodsCount;
            item = Object.assign(item, subItem);
          }
        });
      });
      this.info.saleUsageList = utils.deepClone(list);

      this.$emit('change', this.info);
      this.showGoodsTable = false;
      this.$nextTick(() => {
        this.showGoodsTable = true;
      });
    },
    exchangePharmacistList(val, key) {
      console.log(val);
      this.pharmacistList.forEach((item) => {
        if (item.id === val) {
          this.info[key] = item.name;
        }
      });
    },
    validate() {
      this.info.allocater = utils.isMatchFilter(
        this.pharmacistList,
        this.info.allocater,
      );
      this.info.reviewer = utils.isMatchFilter(
        this.pharmacistList,
        this.info.reviewer,
      );
      if (this.info.diseaseName === '其他') {
        this.salePrescription.additionalRemark = [
          {
            required: true,
            message: '请选择诊断补充说明',
            trigger: 'blur',
          },
        ];
      } else {
        this.salePrescription.additionalRemark = null;
      }

      return new Promise((resolve) => {
        let result = false;

        this.$refs.prescription.validate((valid) => {
          result = valid;
          if (!valid) {
            this.$Message.error('请填写完整信息');
            resolve(valid);
          }
          const namelist = [];
          result
            && this.info.saleUsageList.forEach((item) => {
              console.log(item);
              if (item.isPatientRebuy) {
                // 判定复购提醒增加必填
                (item.usageStartTime
                  && item.rebuyRemindDays
                  && item.medicationCycle)
                  || (result = false);
                namelist.push(item.approvedDrugNames || item.approvedDrugName);
              }
            });
          this.isValidated = true;
          if (valid && !result) {
            this.$Message.error(
              `请在${namelist.join(
                '、',
              )}的商品行填写开始用药时间，用药周期和用药提醒天数`,
            );
          } else if (!valid) {
            this.$Message.error('请按照要求填写');
          }

          resolve(result);
        });
      });
    },
    contactValue(val) {
      this.info.contactPhone = val;
    },
  },
  created() {
    if (this.able) {
      this.salePrescription = {
        prescriptionTime: [
          {
            required: true,
            message: '请输入处方时间',
            trigger: 'blur',
            type: 'date',
          },
        ],
        patientPhone: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: 'blur',
          },
          {
            validator: utils.validate.phoneValidator,
            message: '请输入正确联系方式',
            trigger: 'blur',
          },
        ],
        patientName: [
          {
            required: true,
            message: '请输入患者姓名',
            trigger: 'blur',
          },
        ],
        prescriptionHospital: [
          {
            required: true,
            message: '请输入处方医院',
            trigger: 'blur',
          },
        ],
        patientAge: [
          {
            required: true,
            message: '请输入正确的患者年龄',
            trigger: 'blur',
            type: 'integer',
            min: 0,
          },
        ],
        patientGender: [
          {
            required: true,
            type: 'number',
            message: '请输入患者性别',
            trigger: 'change',
          },
        ],
        prescriptionDoctor: [
          {
            required: true,
            message: '请输入处方医生',
            trigger: 'change',
          },
        ],
        diseaseId: [
          {
            required: true,
            message: '请选择诊断说明',
            trigger: 'change',
            type: 'number',
          },
        ],
        patientIdCard: [
          {
            validator: utils.validate.credentialsValidate,
            trigger: 'blur',
          },
        ],

        goodsUsage: [
          {
            required: true,
            message: '请输入商品用法',
            trigger: 'blur',
          },
        ],
        goodsDosage: [
          {
            required: true,
            message: '请输入商品用量',
            trigger: 'blur',
          },
        ],
        allocater: [
          {
            required: true,
            message: '请输入调配人',
            trigger: 'change',
            type: 'number',
          },
        ],
        reviewer: [
          {
            required: true,
            message: '请输入复核人',
            trigger: 'change',
            type: 'number',
          },
        ],
      };
    } else if (this.isPrescription) {
      this.salePrescription = {
        allocater: [
          {
            required: true,
            message: '请输入调配人',
            trigger: 'change',
            type: 'number',
          },
        ],
        reviewer: [
          {
            required: true,
            message: '请输入复核人',
            trigger: 'change',
            type: 'number',
          },
        ],
      };
    } else {
      this.salePrescription = {};
    }
  },
  mounted() {
    this.getBaseData()
      .then(() => {
        this.info = this.data;
        this.isValidated = false;
        this.setAdditionalRemark();
        // this.notPrescription && this.setAdditionalRemark();
      })
      .catch((err) => {
        utils.handleError(err);
      });
  },
};
</script>
<style scoped lang="less">
.prescription-page {
  margin-top: 20px;
  width: 55%;
}
.image-container {
  position: absolute;
  right: 16px;
  top: 40px;
  width: 45%;
  height: 510px;
}
.image-container-deteail {
  height: 510px;
}
.goodsTable {
  table {
    width: 70vw;
    border-collapse: collapse;
    border: 1px solid #eee;

    tr {
      height: 46px;
    }

    td {
      border: 1px solid #dedede;
      min-width: 83px;
      padding: 0 13px;
      line-height: normal;
    }

    thead {
      background: #fafafa;
      font-weight: 500;
    }
  }

  .detail {
    background: #f5f5f5;
    padding: 12px 24px;

    > td {
      padding-right: 0;

      > div {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .detailItem {
      margin-right: 30px;
    }
  }
}
.ivu-divider-horizontal {
  margin: 12px 0;
  width: 92%;
}
.test1 {
  position: relative;
  overflow: auto;
  min-height: 0;
  max-height: 100px;
}
/deep/ .ivu-select-dropdown {
  z-index: 12;
  padding: 0;
}
/deep/ .ivu-row{
  margin: 18px 0;
}
.nodata {
  color: #9a9a9a;
  font-size: 14px;
  padding: 4px 0 4px 4px;
}
.editRow{
  display: flex;
  justify-content: space-between;
  // margin-bottom: 8px;
  >*:first-child{
    width: 90%;
    >*{

      width: 33%;
    }
  }
}
</style>
